module.exports = __webpack_public_path__ + "assets/eaf3b2b6a8671fdb71eee3580e3a872b.png";